import CustomerTypeActions from "./actions";

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form: {},
  isNewRecord: false,
  showModal: false,
  onSubmit: false,
  single: null,
  helperCustomerType: null,
  errorInternal: false,
  isErrorDelete: false,
};

function CustomerTypeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CustomerTypeActions.RESET_LIST:
      return INITIAL_STATE;
    case CustomerTypeActions.NEW_DATA:
      return {
        ...state,
        isProcessing: false,
        single: null,
        form: INITIAL_STATE.form,
        isNewRecord: true,
        showModal: true,
        isError: false,
      };
    case CustomerTypeActions.UPDATE_DATA:
      return {
        ...state,
        isProcessing: false,
        single: null,
        isNewRecord: false,
        isError: false,
      };
    case CustomerTypeActions.VIEW_DATA:
      return {
        ...state,
        isProcessing: false,
        single: action.payload,
        isNewRecord: false,
        showModal: true,
        isError: false,
      };
    case CustomerTypeActions.RESET_DATA:
      return {
        ...state,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case CustomerTypeActions.DELETE_DATA:
      return {
        ...state,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case CustomerTypeActions.ON_SUBMIT:
      return { ...state, onSubmit: true, isError: false };
    case CustomerTypeActions.SHOW_DATA:
      return {
        ...state,
        isError: false,
        data: action.payload,
        errorMessage: [],
        isProcessing: false,
      };
    case CustomerTypeActions.SUCCESS_DATA:
      return {
        ...state,
        isError: false,
        showModal: false,
        form: INITIAL_STATE.form,
        onSubmit: false,
      };
    case CustomerTypeActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false, isSuccess: false };
    case CustomerTypeActions.ERROR_DATA:
      return {
        ...state,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case CustomerTypeActions.GET_HELPER_TYPE_CUSTOMER:
      return {
        ...state,
        isError: false,
        isSuccess: false,
        onSubmit: false,
        helperCustomerType: action.payload,
      };
    case CustomerTypeActions.ERROR_SERVER:
      return {
        ...state,
        errorInternal: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case CustomerTypeActions.ERROR_DELETE:
      return {
        ...state,
        isError: false,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };

    default:
      return state;
  }
}

export default CustomerTypeReducer;
